import { useCallback } from 'react';
import { ANIMATE_ON_SHOW_DETAILS } from '../../../context/constants';
import { useAnimationHandlersContext } from '../../../context/useAnimationContext';
import { useDelayedCallback } from '../useDelayedCallback';

export const useAddAnimationOnShowHideDetails = ({
    animationType = ANIMATE_ON_SHOW_DETAILS
}) => {
    const { handleSetContainerClasses, handleRemoveContainerClasses } = useAnimationHandlersContext();

    const handleRemoveOnShowHideDetailsAnimationClasses = useCallback(() => {
        handleRemoveContainerClasses(animationType);
    }, [handleRemoveContainerClasses, animationType]);

    const delayedRemove = useDelayedCallback(handleRemoveOnShowHideDetailsAnimationClasses, 1500);

    const handleSetOnShowHideDetailsAnimationClasses = useCallback(() => {
        handleSetContainerClasses(animationType);
        delayedRemove();
    }, [handleSetContainerClasses, animationType, delayedRemove]);

    return {
        handleSetOnShowHideDetailsAnimationClasses,
        handleRemoveOnShowHideDetailsAnimationClasses
    };
};
